/**
 * App-local wrapper — injects brain context-limit URL via SSOT resolver.
 */
import {
  useContextWindowUsage as useContextWindowUsageBase,
  resolveCortexBrainUrl,
  type ContextWindowUsage,
  type ContextWindowMessage,
} from "@flowstate/ai-client";

export type { ContextWindowUsage, ContextWindowMessage };

export function useContextWindowUsage(
  messages: ContextWindowMessage[],
  selectedModel?: string,
  selectedProvider?: string,
): ContextWindowUsage {
  const brainBaseUrl = resolveCortexBrainUrl();
  return useContextWindowUsageBase(messages, selectedModel, selectedProvider, {
    brainBaseUrl,
    enabled: !!brainBaseUrl && !!selectedModel,
  });
}
